/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable prettier/prettier */
import React, { useEffect } from 'react'
import ReactSelect from 'react-select'

import i18n from 'live/services/i18n'

// import { FilteredSearch } from 'plugin-codaf-risk-ext-bowtie/generic'
import { Entity } from 'plugin-codaf-risk-ext-bowtie/types/enums'

import { ListButtonsPagination, PaginationContainer, Search, SelectLimitPagination } from './styles'

interface IProps {
    total: number
    offset: number
    setOffset: (k: number) => void
    limit: ISelect
    setLimit: (k: ISelect) => void
    setPage?: (k: number) => void
    searchString: string
    setSearchString: (k: string) => void
    preset: string
}

interface ISelect {
    value: number
    label: string
}

export const ReportPagination: React.FC<IProps> = ({
    total,
    offset,
    setOffset,
    limit,
    setPage,
    setLimit,
    searchString,
    setSearchString,
    preset
}) => {
    const maxItems = 5
    const maxLeft = (maxItems - 1) / 2
    const current = offset ? offset / limit.value + 1 : 1
    const pages = Math.ceil(total / limit.value)
    const first = Math.max(current - maxLeft, 1)

    const limitOptions = [
        { label: `20 ${i18n('items')} | ${i18n('page')}`, value: 20 },
        { label: `30 ${i18n('items')} | ${i18n('page')}`, value: 30 },
        { label: `40 ${i18n('items')} | ${i18n('page')}`, value: 40 },
        { label: `50 ${i18n('items')} | ${i18n('page')}`, value: 50 },
        { label: `100 ${i18n('items')} | ${i18n('page')}`, value: 100 }
    ]

    function onPageChange(page): void {
        setOffset((page - 1) * limit.value)
        setPage(page)
    }

    function generatePlaceholder(preset: string): string {
        if (preset === Entity.BARRIER) {
            return i18n('Type to search for barrier name')
        }
        if (preset === Entity.CONTROL_BARRIER) {
            return i18n('Type to search for control barrier name')
        }
        if (preset === Entity.ESCALATION_FACTOR) {
            return i18n('Type to search for escalation factor name')
        }
        if (preset === Entity.TOP_EVENT) {
            return i18n('Type to search for top event name')
        }
        if (preset === Entity.THREAT) {
            return i18n('Type to search for threat name')
        }
        if (preset === Entity.CONSEQUENCE) {
            return i18n('Type to search for consequence name')
        }
    }

    useEffect(() => {
        setOffset(0)
    }, [limit.value, setOffset, total])

    useEffect(() => {
        setSearchString('')
    }, [preset])

    return (
        <PaginationContainer>
            <Search>
                <div className="filteredSearch-input">
                    <i className="fa fa-search" />
                    <input
                        id={'engineeringAudit-engineeringAuditPagination-search-input'}
                        placeholder={generatePlaceholder(preset)}
                        onChange={e => setSearchString(e.target.value)}
                        value={searchString}
                    />
                </div>
            </Search>
            <SelectLimitPagination>
                <ReactSelect
                    options={limitOptions}
                    onChange={(item: ISelect) => {
                        setLimit(item)
                    }}
                    value={limit}
                    clearable={false}
                    id="engineeringAudit-engineeringAuditPagination-field-perPage"
                />
            </SelectLimitPagination>
            <ListButtonsPagination>
                <li>
                    <button onClick={() => onPageChange(current - 1)} disabled={current === 1}>
                        <i className="fas fa-chevron-left"></i>
                    </button>
                </li>
                {Array.from({ length: Math.min(maxItems, pages) })
                    .map((_, index) => index + first)
                    .map(page => {
                        if (page <= pages) {
                            return (
                                <li key={page}>
                                    <button
                                        className={page === current && 'active-page'}
                                        onClick={() => onPageChange(page)}
                                    >
                                        {page}
                                    </button>
                                </li>
                            )
                        }
                    })}
                {current <= pages - (maxLeft + 1) && pages > maxItems && (
                    <>
                        <div className="reticence">
                            <div className="circle"></div>
                            <div className="circle"></div>
                            <div className="circle"></div>
                        </div>
                        <li>
                            <button onClick={() => onPageChange(pages)}>{pages}</button>
                        </li>
                    </>
                )}
                <li>
                    <button onClick={() => onPageChange(current + 1)} disabled={current === pages}>
                        <i className="fas fa-chevron-right"></i>
                    </button>
                </li>
            </ListButtonsPagination>
        </PaginationContainer>
    )
}
